<script setup>
import {onMounted, ref} from "vue";
import { useNotificationStore } from '@/stores/NotificationStore.js'
const notificationStore = useNotificationStore()

const appData = ref(null)
const state = ref('')

const loadAppData = async () => {
    const res = await axios.get(route('api.manage-whitelabel-app.manage-app-stores'))
    appData.value = res.data
}

const updateAppData = async () => {
    state.value = 'waiting'
    const res = await axios.put(route('api.manage-whitelabel-app.update-app-stores'), appData.value)

    if (res.data.success) {
        state.value = 'success'
        notificationStore.addNotification({
            type: 'success',
            title: 'App store information saved',
            dismissAfter: 3000,
        })
    }
}

onMounted(() => {
    loadAppData()
})

</script>
<template>
    <div class="pt-8">
        <card-basic v-if="appData && appData.app_enabled">
            <h1>App Stores</h1>
            <p class="text-gray-400 text-xs">
                This information will be displayed on Apple App Store and Google Play Store.<br>
                <em>Changes made here will not be published instantly.</em>
            </p>
            <div class="space-y-6">
                <div>
                    <div class="flex justify-between">
                        <input-label label="Name" />
                        <span class="text-sm text-gray-400">{{ 30 - (appData.app_listing.app_listing_name?.length ?? 0) }}</span>
                    </div>
                    <input-text
                        v-model:content="appData.app_listing.app_listing_name"
                        maxlength="30"
                    >{{ appData.app_listing.app_listing_name }}</input-text>
                </div>
                <div>
                    <div class="flex justify-between">
                        <input-label label="Byline" />
                        <span class="text-sm text-gray-400">{{ 30 - (appData.app_listing.app_listing_byline?.length ?? 0) }}</span>
                    </div>
                    <input-text
                        v-model:content="appData.app_listing.app_listing_byline"
                        maxlength="30"
                    >{{ appData.app_listing.app_listing_byline }}</input-text>
                </div>
                <div>
                    <div class="flex justify-between">
                        <input-label label="Description" />
                        <span class="text-sm text-gray-400">{{ 500 - (appData.app_listing.app_listing_description?.length ?? 0) }}</span>
                    </div>
                    <input-textarea
                        v-model:content="appData.app_listing.app_listing_description"
                        maxlength="500"
                    >{{ appData.app_listing.app_listing_description }}</input-textarea>
                </div>
                <div>
                    <div class="flex justify-between">
                        <input-label label="Keywords (for search in app stores)" />
                        <span class="text-sm text-gray-400">{{ 100 - (appData.app_listing.app_listing_keywords?.length ?? 0) }}</span>
                    </div>

                    <input-text
                        v-model:content="appData.app_listing.app_listing_keywords"
                        maxlength="100"
                    >{{ appData.app_listing.app_listing_keywords }}</input-text>
                </div>
                <div>
                    <input-label label="Support_email" />
                    <input-text
                        v-model:content="appData.app_listing.app_listing_support_email"
                    >{{ appData.app_listing.app_listing_support_email }}</input-text>
                </div>
            </div>

            <div class="flex justify-end">
                <button-success
                    :state="state"
                    @click="updateAppData"
                >
                    Update
                </button-success>
            </div>
        </card-basic>
    </div>
</template>
